module.exports = __webpack_public_path__ + "img/ai-img-logo1.3b0e5d28.png";